import { render, staticRenderFns } from "./relatedCompany.vue?vue&type=template&id=6fa83022&scoped=true&"
import script from "./relatedCompany.vue?vue&type=script&lang=js&"
export * from "./relatedCompany.vue?vue&type=script&lang=js&"
import style0 from "./relatedCompany.vue?vue&type=style&index=0&id=6fa83022&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fa83022",
  null
  
)

export default component.exports